module.exports = __webpack_public_path__ + "static/img/16037B_1_C_20210322_LC.f9b8a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16037B_1_C_20210322_LC.png
// module id = n32a
// module chunks = 0